export default __webpack_public_path__ + "static/media/euro.a031e12b.svg";